import { styled } from '@linaria/react';
import { FileLink } from '../../../../pages/admin/AdminPage.styles';

export const ProcedureCard = styled.div`
    background-color: #f8f9fa;
    border-left: 4px solid #007bff;
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 4px;
`;

export const ProcedureCardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`;

export const ProcedureMeta = styled.div`
    display: flex;
    gap: 1rem;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    color: #6c757d;
`;

export const CategoryLabel = styled.span`
    font-weight: 600;
    color: #007bff;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.5px;
`;

export const ProcedureTitle = styled.h4`
    font-size: 1.1rem;
    font-weight: bold;
    margin-bottom: 0.75rem;
    color: #333;
`;

export const ProcedureFileLink = styled(FileLink)`
    margin-bottom: 0.75rem;
    font-size: 0.9rem;
`;

export const ProcedureDescription = styled.div`
    color: #495057;
    line-height: 1.6;
    margin-bottom: 0.75rem;

    pre {
        white-space: pre-wrap;
        word-wrap: break-word;
        font-family: inherit;
        margin: 0;
    }
`;

export const CommentsSection = styled.div`
    border-top: 1px solid #dee2e6;
    margin-top: 1.5rem;
    padding-top: 1rem;
`;

export const CommentsLabel = styled.div`
    font-weight: bold;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
`;

export const CommentsText = styled.div`
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    padding: 0.75rem;
    border-radius: 4px;
    font-size: 0.875rem;

    pre {
        white-space: pre-wrap;
        word-wrap: break-word;
        font-family: inherit;
        margin: 0;
    }
`;

export const NoProceduresMessage = styled.p`
    font-style: italic;
    color: #6c757d;
    text-align: center;
    padding: 2rem;
`;

// Edit mode styled components
export const EditSelect = styled.select`
    padding: 0.5rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 0.875rem;
    min-width: 200px;
    background-color: #fff;

    &:focus {
        border-color: #007bff;
        outline: none;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }

    &:disabled {
        background-color: #e9ecef;
        cursor: not-allowed;
    }
`;

export const EditTextarea = styled.textarea`
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 0.875rem;
    resize: vertical;
    min-height: 80px;

    &:focus {
        border-color: #007bff;
        outline: none;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }
`;

export const RemoveProcedureButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    padding: 0.25rem;
    opacity: 0.6;
    transition: opacity 0.2s;

    &:hover {
        opacity: 1;
    }
`;

export const AddProcedureWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    align-items: center;
    margin-bottom: 1.5rem;
    padding: 1rem;
    background-color: #e9f5ff;
    border-radius: 4px;
    border: 1px dashed #007bff;

    span {
        font-size: 0.875rem;
        color: #495057;
    }
`;

export const CommentsEditSection = styled.div`
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid #dee2e6;
`;
